import React, { useEffect, useState } from 'react';
import {
    dropdownAction,
    filterDateAction,
    filterPaymentMethodsOptionsAction,
    filterWindowAction,
    resetAllFiltersAction, setCashAction
} from "../../../redux/rootReducer";
import CalendarOffline from "../../CalendarOffline/CalendarOffline";
import FiltersWrapper from "../../FiltersWrapper/FiltersWrapper";
import { useDispatch, useSelector } from "react-redux";
import { getCashThunk } from "../../../redux/thunks/getCashThunk";

const CashHeader = () => {
    const dispatch = useDispatch();
    const filterDate = useSelector(state => state.filterDate);
    const dropdown = useSelector(state => state.dropdown);
    const payment_methods = useSelector(state => state.payment_methods);
    const filterPaymentMethodsOptions = useSelector(state => state.filterPaymentMethodsOptions);

    const cash = useSelector(state => state.cash);

    // Состояние календаря
    const [openFromCalendar, setOpenFromCalendar] = useState(false);
    const [openToCalendar, setOpenToCalendar] = useState(false);

    useEffect(() => {
        dispatch(filterPaymentMethodsOptionsAction(payment_methods.map(elem => ({ ...elem, active: false }))));
    }, [payment_methods]);

    return (
        <>
            <FiltersWrapper>
                <div className="flt__content">
                    <div className="flt__reset" onClick={ () => {
                        // Сброс фильтров
                        dispatch(resetAllFiltersAction());
                    } }>Сбросить фильтры</div>
                    <div className="flt__caption">Фильтры</div>
                    <div className="filter filter--calendar"
                         onClick={ event => {
                             event.preventDefault();
                             event.stopPropagation();
                             setOpenFromCalendar(!openFromCalendar);
                         } }
                    >
                        { `${ filterDate.from ? new Date(filterDate.from).toLocaleDateString('ru-Ru') : 'Дата с' }` }
                        {
                            filterDate.from
                                ? <div className="filter__remove" onClick={ event => {
                                    event.stopPropagation();
                                    dispatch(filterDateAction({ ...filterDate, from: '' }));
                                    dispatch(setCashAction({ ...cash, date_from: '' }));
                                } } />
                                : false
                        }
                    </div>
                    <CalendarOffline
                        style={{ marginTop: 0 }}
                        date={ filterDate.from }
                        handler={ date => {
                            dispatch(filterDateAction({ ...filterDate, from: date }));
                            dispatch(setCashAction({ ...cash, date_from: date }));
                            setOpenFromCalendar(false);
                        }}
                        open={ openFromCalendar }
                        close={ () => setOpenFromCalendar(false) }
                    />
                    <div className="filter filter--calendar"
                         onClick={ event => {
                             event.preventDefault();
                             event.stopPropagation();
                             setOpenToCalendar(!openToCalendar);
                         } }
                    >
                        { `${ filterDate.to ? new Date(filterDate.to).toLocaleDateString('ru-Ru') : 'Дата по' }` }
                        {
                            filterDate.to
                                ? <div className="filter__remove" onClick={ event => {
                                    event.stopPropagation();
                                    dispatch(filterDateAction({ ...filterDate, to: '' }));
                                    dispatch(setCashAction({ ...cash, date_to: '' }));
                                } } />
                                : false
                        }
                    </div>
                    <CalendarOffline
                        style={{ marginTop: 0 }}
                        date={ filterDate.to }
                        handler={ date => {
                            dispatch(filterDateAction({ ...filterDate, to: date }));
                            dispatch(setCashAction({ ...cash, date_to: date }));
                            setOpenToCalendar(false);
                        }}
                        open={ openToCalendar }
                        close={ () => setOpenToCalendar(false) }
                    />

                    <div className="notifications__field">
                        <div className="dropdown">
                            <div className="filter"
                                 onClick={ () => dispatch(dropdownAction('payment_method')) }
                            >
                                { cash.payment_method.name || 'Метод оплаты' }
                            </div>
                            <div className={ `dropdown__items ${ dropdown === 'payment_method' ? 'dropdown__items--open' : false }` }>
                                {
                                    filterPaymentMethodsOptions.map(elem => {
                                            return (
                                                <div
                                                    key={ elem.id }
                                                    className="dropdown__item"
                                                    onClick={ () => {
                                                        dispatch(setCashAction({
                                                            ...cash,
                                                            payment_method: elem
                                                        }));
                                                        dispatch(dropdownAction(null));
                                                    } }
                                                >
                                                    { elem.name }
                                                </div>
                                            );
                                        })
                                }
                            </div>
                        </div>
                    </div>

                    <div className="button button--blue"
                         onClick={ () => {
                             // Закрываем фильтры
                             dispatch(filterWindowAction(false));
                             // Применяем фильтры
                             dispatch(getCashThunk({
                                 date_from: cash.date_from,
                                 date_to: cash.date_to,
                                 payment_method: cash.payment_method.id
                             }));
                         } }
                    >Применить</div>
                </div>
            </FiltersWrapper>
        </>
    );
};

export default CashHeader;